import { render, staticRenderFns } from "./cake.vue?vue&type=template&id=9641297c&scoped=true&"
import script from "./cake.vue?vue&type=script&lang=js&"
export * from "./cake.vue?vue&type=script&lang=js&"
import style0 from "./cake.vue?vue&type=style&index=0&id=9641297c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9641297c",
  null
  
)

export default component.exports